import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesCommissionPaymentsView } from "src/components/views/erp/sales/salesCommissions/paymentsView/SalesCommissionPaymentsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/salesCommissions/payments")({
	staticData: { title: i18n.t("commission_payments"), legacyViewKey: "salesCommissionPaymentsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesCommissionPaymentsView />;
}
